import { Loading, adicionaZero } from "../components"
import domtoimage from "../components/domToImage/dom-to-image"
import { nomesMeses } from "../layout/redux/layoutReducer"
import grafico from "../modules/empresa/csatcliente/grafico"



//ADICIONADO PARA CHECAGEM DE CPF NA CAPTURA ANTES DO CHECKOUT
export const formatarCPF = (valor = '') => {
  // Remove tudo que não for dígito
  const cpfApenasDigitos = valor.replace(/\D/g, '')
  
  // Limita a 11 dígitos
  const cpfLimitado = cpfApenasDigitos.slice(0, 11)

  // Aplica a máscara -> ###.###.###-##
  let cpfFormatado = cpfLimitado
  if (cpfLimitado.length > 3) {
    cpfFormatado = cpfLimitado.slice(0, 3) + '.' + cpfLimitado.slice(3)
  }
  if (cpfLimitado.length > 6) {
    cpfFormatado = cpfFormatado.slice(0, 7) + '.' + cpfFormatado.slice(7)
  }
  if (cpfLimitado.length > 9) {
    cpfFormatado = cpfFormatado.slice(0, 11) + '-' + cpfFormatado.slice(11)
  }

  return cpfFormatado
}

//MESMA COISA PARA CNPJ
export const formatarCNPJ = (valor = '') => {
  // Remove tudo que não for dígito
  let cnpjSoDigitos = valor.replace(/\D/g, '')
  
  // Limita a 14 dígitos
  cnpjSoDigitos = cnpjSoDigitos.slice(0, 14)

  // Aplica a máscara -> ##.###.###/####-##
  let formatado = cnpjSoDigitos
  if (cnpjSoDigitos.length > 2) {
    formatado = cnpjSoDigitos.slice(0, 2) + '.' + cnpjSoDigitos.slice(2)
  }
  if (cnpjSoDigitos.length > 5) {
    formatado = formatado.slice(0, 6) + '.' + formatado.slice(6)
  }
  if (cnpjSoDigitos.length > 8) {
    formatado = formatado.slice(0, 10) + '/' + formatado.slice(10)
  }
  if (cnpjSoDigitos.length > 12) {
    formatado = formatado.slice(0, 15) + '-' + formatado.slice(15)
  }

  return formatado
}



export const paramsApi = e => {
  let params = ``
  if (e) {
    params = `?`
    Object.keys(e).map((par)=> {
      params = `${params === '?' ? params : params + '&'}${par}=${e[par]}`
    })
  }
  return params
}

export const numberZero = (number) => {
  return ("00" + Number(number)).slice(-2)
}

export const capitalize = (str) => {
  if (typeof str !== 'string') {
  return str;
}
return str.charAt(0).toUpperCase() + str.substr(1);
}



export const PageLoadView = ({ 
  load, 
  data, 
  children, 
  erroaocarregar,
  semdadosparaexibir,
  erroMessage = <p className="pageloadview-message-erro">Erro ao carregar</p>, 
  vazioMessage = <p className="pageloadview-message-erro">Sem dados para exibir</p>, 
  height = '500px' 
}) => {
  if (load) {
    console.log("PageLoadView1")
    return <Loading type='element' title='' height={height} />
  } else {
    if (data === undefined) {
      console.log("PageLoadView2")
      return <div className="pageloadview-message">{semdadosparaexibir}</div>
    } else if (data && data.length) {
      console.log("PageLoadView3")
      return children
    } else {
      console.log("PageLoadView4")
      return <div className="pageloadview-message">{semdadosparaexibir}</div>
    }
  }
}



export const cicloIntervalo = e => {
  const data = e.anoMesCiclo.split('-') 
  const mes = nomesMeses.find(nm=> Number(nm.id) === Number(data[1]))
  const cicloPorExtenso = e.cicloPorExtenso ? e.cicloPorExtenso : `${mes.name}-${data[0]}`
  return {...e, mesAno:`${cicloPorExtenso}`, anoMes:`${data[0]}-${data[1]}`, ano: data[0], mes: data[1]}

  //TESTE
  //const idioma = 'en'; 
  //const nls = require(`../layout/nls/${idiomafinal}.json`)
  //console.error(idiomafinal,'ENTREI CicloIntervalo')
  //const mes = nomesMeses.find(nm=> Number(nm.id) === Number(data[1]))
  //const mes = nls.nomesMeses1.find(nm=> Number(nm.id) === Number(data[1]))
  
}

export const numberFormat = (valor, type = 2) => {
  return valor.toFixed(type)
}


export const convertChart = async ({id, titlePage}) => {
  var node = document.getElementById(id);

  try {
    const dataUrl = await domtoimage.toPng(node)
    const date = new Date()
    if (dataUrl) {
      let a = document.createElement("a");
      a.href = dataUrl;
      a.download = `grafico-${titlePage.replace(' ', '_')}_${numberZero(date.getDay())}-${numberZero(date.getMonth())}-${date.getFullYear()}_${date.getHours()}${date.getMinutes()}.png`;
      a.click();
    }
  } catch (error) {
    console.error('oops, something went wrong!', error);
  }
  return false
}

export const downloadArchive = async ({archive, name, extension}) => {
    let a = document.createElement("a");
    a.href = archive;
    a.download = `${name}.${extension}`;
    a.click();
}

export const numberAleatori = (valor=99999999999999) => {
  return Math.floor(Math.random() * valor)
}




//SÓ PARA PRODUTO
export const graficoCustomProduto = (e, p, t, labelgraf) => {
  let dataProjeto = e?.data?.map(data => {
    let itensProjeto = {};

    data.item = data.item.map(item => ({ ...item, valor: Number(item.valor) }));

    data.item.map(item => {
      if (t) {
        const itemlabels = e.labels.find(il => il.type === item.chave);

        itensProjeto = {
          ...itensProjeto,
          [item.chave]: Number(item.valor),

          // Usa chaves fixas para "Atual" e "Anterior"
          ...(item.chave.includes('Atual') ? {
            Atual: Number(item.valor),
            colorAtual: itemlabels?.color,
            key: item.chave.replace('Atual', '')
          } : {}),

          ...(item.chave.includes('Anterior') ? {
            Anterior: Number(item.valor),
            colorAnterior: itemlabels?.color,
            key: item.chave.replace('Anterior', '')
          } : {})
        };
      } else {
        itensProjeto = { ...itensProjeto, [item.chave]: Number(item.valor) };
      }
    });

    return {
      ...data,
      ...itensProjeto
    };
  });

  let analiseProjeto = '';
  if (e.analise && e.analise.length) {
    e.analise.map(ap => {
      analiseProjeto += `<p><strong>${ap.topico}</strong> ${ap.texto}</p>`;
    });
  }

  const grafico = {
    data: dataProjeto,

    // Ajusta os types para manter compatibilidade com dataKey/fill
    labels: e.labels.map(l => {
      if (l.type === labelgraf.atual) return { ...l, type: 'Atual' };
      if (l.type === labelgraf.anterior) return { ...l, type: 'Anterior' };
      return l;
    }),

    analiseGrafica: analiseProjeto,

    ...(e.media ? { media: e.media } : {}),
    ...(e.desvio ? { desvio: e.desvio } : {})
  };

  console.log("GRAFICO EM GRAFICOCUSTOM:", grafico);
  return grafico;
};




//PARA O GRÁFICO DE ESTABELECIMENTOS
export const graficoCustom = (e, p, t, labelgraf ) => {
  let dataProjeto = e?.data?.map(data => {
    let itensProjeto = {}
    data.item = data.item.map(item=> ({...item, valor: Number(item.valor)}))
    data.item.map(item => {
      if (t) {
        const itemlabels = e.labels.find(il=> il.type === item.chave)
        // console.warn(itemlabels, 'itemlabelsitemlabelsitemlabelsitemlabelsitemlabels');
        itensProjeto = { 
          ...itensProjeto, 
          [item.chave]: Number(item.valor),
          //... item.chave.includes('Atual')? {Atual: Number(item.valor), colorAtual: itemlabels.color, key: item.chave.replace('Atual', '')}:{}, 
          //... item.chave.includes('Anterior')? {Anterior: Number(item.valor), colorAnterior: itemlabels.color, key: item.chave.replace('Anterior', '')}:{},
        
          ... item.chave.includes(labelgraf.atual)? {Atual: Number(item.valor), colorAtual: itemlabels.color, key: item.chave.replace(labelgraf.atual, '')}:{}, 
          ... item.chave.includes(labelgraf.anterior)? {Anterior: Number(item.valor), colorAnterior: itemlabels.color, key: item.chave.replace(labelgraf.anterior, '')}:{},
       
        
        }
      } else {
        itensProjeto = { ...itensProjeto, [item.chave]: Number(item.valor) }
      }
    })
    return {
      ...data,
      ...itensProjeto,
    }
  })

  let analiseProjeto = ''
  if (e.analise && e.analise.length) {
    e.analise.map(ap=> {
        analiseProjeto = `${analiseProjeto}<p><strong>${ap.topico}</strong> ${ap.texto}</p>`
    })
  }
  const grafico = {
    data: dataProjeto,
    labels: e.labels,
    analiseGrafica: analiseProjeto,
    
    ...e.media?{media:e.media}:{},
    ...e.desvio?{desvio:e.desvio}:{},
  }

  console.log("GRAFICO EM GRAFICOCUSTOM:", grafico)
  return grafico
}

export const BarCustom = (props) => {
  const { fill, x, y, width, height } = props;
  if (height < 0) {
    const heightCustom = Math.abs(height) 
    return <rect x={x} y={y - heightCustom} width={width} height={Number(heightCustom)}  rx="6" fill={props[`color${fill}`]} />
  } else {
    return <rect x={x} y={y} width={width} height={height}  rx="6" fill={props[`color${fill}`]} />
  }
};


//PARA ESTABELECIMENTO
export const CustomTooltipCustom = ({
  active,
  payload,
  label,
  labels,
  labelgraf,
  msgNA,
  exibirPercentual = false // valor padrão para evitar erro se não for passado
}) => {
  if (active) {
    console.log("CustomTooltipCustom Props:", { active, payload, label, labels, labelgraf });
  }

  return active && payload && payload.length ? (
    <div className="custom-tooltip">
      <p className="label">{`${label}`}</p>
      {payload.map((infopay, i) => {
        const { name, value } = infopay;
        const normalizedName =
          name === "Atual" ? labelgraf.atual : name === "Anterior" ? labelgraf.anterior : name;

        const isDataInvalid = infopay.payload.item?.[i]?.info === -1;

        const displayValue = isDataInvalid
          ? msgNA
          : `${value}${exibirPercentual ? '%' : ''}`;

        const labelItem = labels.find(f => f.type === `${normalizedName}${infopay.payload.key}`);
        const nomeExibido = labelItem?.name || 'Rótulo não encontrado';

        return (
          <p className="desc" key={`tooltipcustom-${name}-${i}`}>
            <span style={{ backgroundColor: infopay.payload[`color${name}`] }}></span>
            {`${nomeExibido} : ${displayValue}`}
          </p>
        );
      })}
    </div>
  ) : null;
};


//PARA PRODUTO
export const CustomTooltipCustomProduto = ({
  active,
  payload,
  label,
  labels,
  labelgraf,
  msgNA,
  exibirPercentual = false
}) => {
  if (active) {
    console.log("CustomTooltipCustomProduto Props:", { active, payload, label, labels, labelgraf });
  }

  return active && payload && payload.length ? (
    <div className="custom-tooltip">
      <p className="label">{`${label}`}</p>
      {payload.map((infopay, i) => {
        const { name, value } = infopay;

        const isDataInvalid = infopay.payload.item?.[i]?.info === -1;

        const displayValue = isDataInvalid
          ? msgNA
          : `${value}${exibirPercentual ? '%' : ''}`;

        const keyPayload = infopay.payload?.key;

        // NOVA LÓGICA: verifica se o type começa com "Atual"/"Anterior" e termina com a key
        const labelItem = labels.find(f =>
          f.type?.startsWith(name) && f.type?.endsWith(keyPayload)
        );

        const nomeExibido = labelItem?.name || 'Rótulo não encontrado';

        return (
          <p className="desc" key={`tooltipcustom-${name}-${i}`}>
            <span style={{ backgroundColor: infopay.payload?.[`color${name}`] }}></span>
            {`${nomeExibido} : ${displayValue}`}
          </p>
        );
      })}
    </div>
  ) : null;
};



//Não colocava % quando vinha de csat concorrentes produtos ou estabelecimentos
/*
export const CustomTooltipCustomOLD = ({ active, payload, label, labels, labelgraf, msgNA }) => {
  if (active) {
    console.log("CustomTooltipCustom Props:", { active, payload, label, labels, labelgraf });
  }

  return active && payload && payload.length ? (
    <div className="custom-tooltip">
      <p className="label">{`${label}`}</p>
      {payload.map((infopay, i) => {
        const { name, value } = infopay;
        const normalizedName =
          name === "Atual" ? labelgraf.atual : name === "Anterior" ? labelgraf.anterior : name;

        // Verifica se o dado é válido
        const isDataInvalid = infopay.payload.item?.[i]?.info === -1;
        const displayValue = isDataInvalid ? msgNA : `${value}`;

        const labelItem = labels.filter(f => f.type === `${normalizedName}${infopay.payload.key}`);

        return (
          <p className="desc" key={`tooltipcustom-${name}-${i}`}>
            <span style={{ backgroundColor: infopay.payload[`color${name}`] }}></span>
            {`${labelItem.length ? labelItem[0].name : 'Rótulo não encontrado'} : ${displayValue}`}
          </p>
        );
      })}
    </div>
  ) : null;
};

*/



/*
export const CustomTooltipCustomOLDCOMPROBLEMADOLABEL = ({ active, payload, label, labels }) => {

  if (active) {
    console.log("CustomTooltipCustom Props:", { active, payload, label, labels });
  }
  return (active && payload && payload.length ? (
  <div className="custom-tooltip">
    <p className="label">{`${label}`}</p>
    {payload.map((infopay, i)=> {
      const {name, value, color} = infopay
      const labelItem = labels.filter(f=> f.type === `${name}${infopay.payload.key}`)
      return (
      <p className="desc"key={`tooltipcustom-${name}-${i}`}>
        <span style={{backgroundColor: infopay.payload[`color${name}`]}}></span> 
        {`${labelItem.length && labelItem[0].name} : ${value}${'%'}`}
      </p>
    )})}
  </div>
):  null)}
*/


export const RenderLegendCustom = ({ payload, labels }) => {
  return (
    <div className={`custom-legend legend-right`}>
      {labels.map((label, i) => {
        return (
        <div key={`item-${i}`}>
          <span style={{backgroundColor: label.color}}></span> 
          {label.name}
        </div>
      )})}
    </div>
  )
}

export const IF = ({se=false, children}) => {
  return se?children:null
}

export const idRdm = (valor=999) => {
  return Math.floor(Math.random() * valor)
}

export const idiomaString = (idioma='pt-br') => {
  idioma = idioma === 'en'?'en-US':idioma
  const idiomaSplit = idioma.split('-')
  return idiomaSplit.length>1?idioma.replace(idiomaSplit[1], idiomaSplit[1].toUpperCase()): idioma
}



export const idiomaCustom = e => {
  e = e === 'en-US'?'en':e
  return e.toLowerCase()
}

export const normalizeText = e => {
  return e.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

export const filterList = (s, t, l) => {
  const list = l.filter(e=> normalizeText(e[t]).includes(normalizeText(s)))
  return list
}


